<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">{{title}}</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction align-center justify-center">
                <i class="font-size-big" :class="iconfont" v-if="iconVisible"></i>
                <div class="tips">{{tips}}</div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate" @click="submit"> 确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "ResultMessageDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
            },
            tips:{
                type: String,
            },
            iconfont:{
                type: String,
            },
            iconVisible: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {

            }
        },
        created() {
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.applyServer();
                    }
                });
            },
            async submit(){
                this.$emit('watchState', true)
            },
            cancel() {
                this.$emit('watchState', false)
            }
        },
        watch: {
            applyDialogVisible(){
            }
        }
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 30px;
                .font-size-big{
                    font-size: 80px;
                    color: #63a35c;
                }
                .tips{
                    font-size: 16px;
                    margin-top: 12px;
                    text-align: center;
                    line-height: 22px;
                    font-weight: bold;
                    color: #0a2240;
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate+.operate{
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>